<template>
  <div>
    <!-- 景区管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>分销商管理</el-breadcrumb-item>
      <el-breadcrumb-item>一级分销商列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片开始 -->
    <el-card style="margin-top:20px;">
      <div class="conentBox">
        <div>
          <div>
            <el-input v-model="serachData.name" placeholder="分销商名称" clearable />
          </div>

          <div>
            <el-select v-model="serachData.province" placeholder="全部省份" clearable>
              <el-option
                v-for="item in cityProvince"
                :key="item.provinceCode"
                :label="item.provinceName"
                :value="item.provinceCode"
              ></el-option>
            </el-select>

            <el-select v-model="serachData.status" placeholder="全部状态" clearable>
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <el-button type="primary" @click="searchFn()">查询</el-button>
        </div>

        <div>
          <el-button type="primary" plain @click="detailFn()">
            <i class="iconfont icon-jiahao"></i>
            添加分销商
          </el-button>
        </div>
      </div>

      <el-table
        :data="fxsOneTableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
      <el-table-column prop="DistributorID" label="分销商id"></el-table-column>
        <el-table-column prop="Name" label="一级分销商"></el-table-column>
        <!--  -->
        <!-- <el-table-column prop="third_system" label="三方系统"></el-table-column> -->

        <el-table-column prop="user_name" label="超管账号"></el-table-column>
        <el-table-column prop="UserCode" label="登录代码"></el-table-column>
        <el-table-column prop="LinkMan" label="联系人"></el-table-column>
        <el-table-column prop="Phone" label="电话"></el-table-column>
        <el-table-column prop="E_Mail" label="Email"></el-table-column>
        <el-table-column prop="Balance" label="余额"></el-table-column>
        <el-table-column label="分销商状态">
          <template slot-scope="scope">
            <img
              v-if="scope.row.Status==1"
              style=" vertical-align: middle;"
              src="@/images/worke/dl.png"
              alt
            />
            <img v-else style=" vertical-align: middle;" src="@/images/worke/dr.png" alt />
            <el-button type="text" @click="stateFn(scope.row)">
              <span v-if="scope.row.Status==1">上线</span>
              <span v-else>下线</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
        <el-table-column prop="address" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="text" @click="changePassw(scope.row)">修改密码</el-button>
            <el-button type="text" @click="recordFn(scope.row)">充值记录</el-button>
            <el-button type="text" @click="detailFn(scope.row)">详情</el-button>
            <el-button type="text" @click="authorFn(scope.row)">授权</el-button>
            <el-button type="text" @click="clientFn(scope.row)">客户端</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <!-- <el-pagination
          @current-change="handleCurrentChange"
          :current-page="oneFxsPar.page"
          :page-size="8"
          background
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{oneFxsPar.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="oneFxsPar.page"  @current-change="handleCurrentChange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 卡片结束 -->
    <!-- 详情弹框开始 -->
    <oneDetailsDialog v-if="defailvisible" ref="defailDialog"></oneDetailsDialog>
    <!-- 详情弹框结束 -->
    <!-- 充值记录弹框开始 -->
    <oneRecordDialog v-if="recordvisible" ref="recordDialog"></oneRecordDialog>
    <!-- 充值记录弹框结束 -->
    <!-- 修改密码弹框开始 -->
    <onePassWordDialog v-if="passwvisible" ref="passwDialog"></onePassWordDialog>
    <!-- 修改密码弹框结束 -->
    <!-- 授权弹框开始 -->
    <twoAutorDialog v-if="autorvisible" ref="autorDialog"></twoAutorDialog>
    <!-- 授权弹框结束 -->

    <!-- 信息上下线弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="信息"
      :visible.sync="stateDialogVisible"
      :before-close="stateHandleClose"
      width="24%"
      top="30vh"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>
      <div class="autorYj">
        <div>
          <div class="fswc">
            <el-radio-group v-model="statusXx">
              <el-radio :label="1">上线</el-radio>
              <el-radio :label="2">下线</el-radio>
            </el-radio-group>
          </div>
          <div class="autorBtn">
            <el-button class="btnCan" type="text" @click="canclFn">取消</el-button>
            <el-button class="btnSure" type="text" @click="msgFn()">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 信息上下线弹框结束 -->
  </div>
</template>

<script>
import {
  adminGetDistributorListPost,
  adminDistributorUpdateStatusPost,
  jfyDistributorLogin
} from "@/request/fxs.js";
import oneDetailsDialog from "./oneDetailsDialog.vue";
import oneRecordDialog from "./oneRecordDialog.vue";
import onePassWordDialog from "./onePassWordDialog.vue";
import twoAutorDialog from "./twoAutorDialog.vue";
import cityOptions from "@/assets/city.json";
export default {
  components: {
    oneDetailsDialog,
    oneRecordDialog,
    onePassWordDialog,
    twoAutorDialog
  },
  data() {
    return {
      autorvisible: false, // 授权弹框
      defailvisible: false, // 详情弹框
      recordvisible: false, // 充值记录
      passwvisible: false, // 修改密码
      stateDialogVisible: false, // 信息上下线
      statusXx: "", // 信息上下线
      // 一级分销商传参
      oneFxsPar: {
        name: "",
        status: "",
        proid: "",
        page: 1,
        page_size: 8,
        token: ""
      },
      // 查询
      serachData: {
        name: "",
        province: "",
        status: ""
      },
      // 上下线传参
      statusPar: {
        distributor_id: "",
        status: "",
        token: ""
      },
      distributorId: "", // 分销商id储存
      total: 1,

      cityProvince: [], // 全部省份

      // 状态下拉
      statusOptions: [
        {
          value: 1,
          label: "正常 "
        },
        {
          value: 2,
          label: "停用  "
        },
        {
          value: 3,
          label: "待审核 "
        },
        {
          value: 4,
          label: "未通过"
        },
        {
          value: 5,
          label: "删除"
        }
      ],
      fxsOneTableData: [], // 列表绑定状态

      imgXl: require("@/images/scenic/sj.png"),
      imgXlb: require("@/images/scenic/sjh.png"),
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄"
        }
      ],
      options: [
        {
          value: 1,
          label: "正常 "
        }
      ],
      value: "",
      radio: ""
    };
  },
  mounted() {
    this.Token = window.sessionStorage.getItem("Token");
    this.oneFxsPar = {
      name: "",
      status: "",
      proid: "",
      page: 1,
      page_size: 8,
      token: this.Token
    };
    this.getList(this.oneFxsPar);
    this.cityProvince = cityOptions;
    console.log(cityOptions);
  },
  methods: {
    // 点击客户端
    clientFn(row) {
      let data = {
        distributor_id:row.DistributorID,
        token:window.sessionStorage.getItem('Token')
      }
      jfyDistributorLogin(data).then(res=>{
        if(res.data.status=='ok'){
          window.open("/homeFxs?data=" + JSON.stringify(res.data.result), "_blank");
        }
      })
    },
    // 获取列表数据
    getList(data) {
      adminGetDistributorListPost(data).then(res => {
        console.log(res);
        this.total = res.data.result.total;
        this.fxsOneTableData = res.data.result.data;
      });
    },
    // 搜索
    searchFn() {
      this.oneFxsPar.page = 1;
      this.oneFxsPar.name = this.serachData.name;
      this.oneFxsPar.proid = this.serachData.province;
      this.oneFxsPar.status = this.serachData.status;
      this.getList(this.oneFxsPar);
    },
    // 点击授权
    authorFn(row) {
      this.autorvisible = true;
      this.$nextTick(() => {
        this.$refs.autorDialog.autor(row);
      });
    },
    // 点击修改密码
    changePassw(row) {
      this.passwvisible = true;
      this.$nextTick(() => {
        this.$refs.passwDialog.passw(row);
      });
    },
    // 点击充值记录
    recordFn(row) {
      this.recordvisible = true;
      this.$nextTick(() => {
        this.$refs.recordDialog.recharge(row);
      });
    },
    // 点击详情
    detailFn(row) {
      this.defailvisible = true;
      this.$nextTick(() => {
        this.$refs.defailDialog.defail(row);
      });
    },
    // 点击状态
    stateFn(row) {
      console.log(row);
      this.distributorId = row.DistributorID;
      this.statusXx = row.Status;
      if (row.Status == 1) {
        this.statusXx = 1;
      } else {
        this.statusXx = 2;
      }
      this.stateDialogVisible = true;
    },
    // 信息确认按钮
    msgFn() {
      this.statusPar = {
        distributor_id: this.distributorId,
        status: this.statusXx,
        token: this.Token
      };
      // this.oneFxsPar.status = this.statusXx;
      adminDistributorUpdateStatusPost(this.statusPar).then(res => {
        console.log(res);
        if (res.data.rcode == 200) {
          this.stateDialogVisible = false;
          let upData = {
            token: this.Token
          };
          this.getList(upData);
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 信息按钮取消
    canclFn() {
      this.stateDialogVisible = false;
    },
    // 点击状态关闭X
    stateHandleClose() {
      this.stateDialogVisible = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.oneFxsPar.page = val;
      this.getList(this.oneFxsPar);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.conentBox {
  display: flex;
  margin-bottom: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
  > div:nth-child(1) {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    > div:nth-child(1) {
      /deep/.el-input {
        width: 240px;
        margin-right: 20px;
        margin-bottom: 1rem;
      }
    }
    > div:nth-child(2) {
      /deep/.el-select {
        width: 260px;
        margin-right: 20px;
        margin-bottom: 1rem;
      }
    }
    .el-button {
      width: 100px;
      margin-bottom: 1rem;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: flex-end;
    .el-button {
      margin-bottom: 1rem;
      width: 120px;
      display: flex;
      justify-content: center;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      // margin-right: -272px;
      color: #246deb;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
    }
  }
}
.autorYj {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 40px;
  .autorBtn {
    margin-top: 42px;
    .btnCan {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ffffff;
    }
    .btnSure {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ffffff;
    }
  }
}
.autorDialog {
  /deep/.el-dialog--center {
    text-align: center;
    height: 266px;
  }
  .autorYj {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 40px;
    .autorBtn {
      margin-top: 42px;
      .btnCan {
        width: 100px;
        height: 40px;
        background: #d9d9d9;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
      .btnSure {
        width: 100px;
        height: 40px;
        background: #246deb;
        border-radius: 4px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        /* identical to box height */
        color: #ffffff;
      }
    }
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
/deep/ .el-dialog{
  min-width: 400px;
}
/deep/ .el-dialog__headerbtn{
  top:3px;
}
/deep/ .el-dialog__title{
   color: #000 !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}
</style>